import { render } from "./TalALibrary.vue?vue&type=template&id=5d5edd5e&scoped=true"
import script from "./TalALibrary.vue?vue&type=script&lang=js"
export * from "./TalALibrary.vue?vue&type=script&lang=js"

import "./TalALibrary.vue?vue&type=style&index=0&id=5d5edd5e&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5edd5e"]])

export default __exports__